export const adminRouteNames = {
   USERS: 'users',
   EDIT: 'edit',
   NEW: 'new',
   PERMISSIONS: 'permissions',
};
